import {
    Activity,
    Bot,
    Building2,
    CircleDollarSign,
    CirclePlay,
    LayoutDashboard,
    Package,
    Sparkles,
    Users,
} from 'lucide-react';
import {
    SidebarContent,
    SidebarFooter,
    SidebarHeader,
    SidebarSeparator,
} from '@/components/ui/sidebar';
import SidebarNavGroup from '@/components/SidebarNavGroup';
import { AvatarMenu } from '@/components/AvatarMenu';
import AdminPanelHeader from './AdminPanelHeader';
import { StyledAdminSidebar, StyledAdminSidebarContent } from './styled';

const overviewMenuItems = [
    {
        title: 'Dashboard',
        path: 'dashboard',
        icon: LayoutDashboard,
    },
    {
        title: 'Workflow Ops',
        path: 'workflow-ops',
        icon: Activity,
    },
];

const operationsMenuItems = [
    {
        title: 'Playbooks',
        path: 'playbooks',
        icon: CirclePlay,
    },
    {
        title: 'Team',
        path: 'team',
        icon: Users,
    },
];

const businessMenuItems = [
    {
        title: 'Organizations',
        path: 'organizations',
        icon: Building2,
    },
    {
        title: 'Services',
        path: 'services',
        icon: Package,
    },
    {
        title: 'Platform Costs',
        path: 'platform-costs',
        icon: CircleDollarSign,
    },
];

const platformMenuItems = [
    {
        title: 'System Agents',
        path: 'system-agents',
        icon: Bot,
    },
    {
        title: 'Skills',
        path: 'skills',
        icon: Sparkles,
    },
];

export function AdminSidebar() {
    const overviewItems = overviewMenuItems.map(item => ({
        ...item,
        url: `/admin/${item.path}`,
    }));
    const operationsItems = operationsMenuItems.map(item => ({
        ...item,
        url: `/admin/${item.path}`,
    }));
    const businessItems = businessMenuItems.map(item => ({
        ...item,
        url: `/admin/${item.path}`,
    }));
    const platformItems = platformMenuItems.map(item => ({
        ...item,
        url: `/admin/${item.path}`,
    }));

    return (
        <StyledAdminSidebar data-print-hide="true">
            <SidebarHeader className="p-4">
                <AdminPanelHeader />
            </SidebarHeader>
            <SidebarContent>
                <StyledAdminSidebarContent>
                    <SidebarNavGroup label="Overview" items={overviewItems} />
                    <SidebarNavGroup label="Operations" items={operationsItems} />
                    <SidebarNavGroup label="Business" items={businessItems} />
                    <SidebarNavGroup label="Platform" items={platformItems} />
                </StyledAdminSidebarContent>
            </SidebarContent>
            <SidebarFooter>
                <div className="px-3">
                    <SidebarSeparator className="mx-0" />
                </div>
                <AvatarMenu variant="admin" />
            </SidebarFooter>
        </StyledAdminSidebar>
    );
}
